export default __webpack_public_path__ + "static/media/hpl-logo-gray.80c94b28.png";